//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isEmpty } from "@/utils/validate";
export default {
  props: [
    "tableCheckAll",
    "tableData",
    "searchType",
    "filterLoading",
    "listLoading",
    "filterWhere",
    "crrSortName",
    "crrOrderName",
    "filterJson",
    "picOrList",
    "listKey",
    "picListKey",
    "searchCard",
    "pageName",
    "isSearch",
    "edition" // 是简易版本 还是高级版本
  ],
  data() {
    return {
      reviewDialog: false,
      reviewNameArr: [],
    };
  },
  mounted() { },
  watch: {
    // tableData: {
    //   handler(newName, oldName) {
    //     console.log(newName.checked);
    //   },
    //   deep: true
    // }
  },
  methods: {
    showPic() {
      this.$emit("update:picOrList", !this.picOrList);
    },
    checkList(tab, i) {
      this.$emit("checkList", tab, i);
    },
    goDetails(item) {
      this.$emit("goDetails", item);
    },
    tableCheckAllChange() {
      this.$emit("tableCheckAllChange");
    },
    filterListSort(order, sort) {
      console.log(454654)
      this.$emit("filterListSort", order, sort);
    },
    filterConfirm() {
      this.$emit("filterConfirm");
    },
    getSearchFilter(pam, nameText) {
      this.$emit("getSearchFilter", pam, nameText);
    },
    copyInfo(txt) {
      var ok = this.tools.copy(false, txt);
      this.$message({
        showClose: true,
        message: ok ? "复制成功" : "复制失败",
        type: ok ? "success" : "warning"
      });
    },
    //复查
    /*reviewName(item) {
      console.log(item)
      if (
        (!isEmpty(item.cn) && !isEmpty(item.en)) ||
        (!isEmpty(item.cn) && !isEmpty(item.num)) ||
        (!isEmpty(item.en) && !isEmpty(item.num))
      ) {
        this.reviewNameArr = [];
        if (!isEmpty(item.cn)) {
          this.reviewNameArr.push(item.cn);
        }
        if (!isEmpty(item.en)) {
          this.reviewNameArr.push(item.en);
        }
        if (!isEmpty(item.num)) {
          this.reviewNameArr.push(item.num);
        }
        this.reviewDialog = true;
      } else {
        this.openType1(item.cn);
        this.openType1(item.en);
        this.openType1(item.num);
      }
    },
    openType1(keyword) {
      if (!isEmpty(keyword)) {
        window.open("/trademarkSearch?type=1&text=" + keyword, "_blank");
      }
    },*/
    goAgentByName(item) {
      window.open("/trademarkSearch?type=5&text=" + item.agentName, "_blank");
    }
  }
};
